import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  CONNECT_ACH_BANK_ACCOUNTS,
  FETCH_BANK_ACCOUNTS,
} from '../actions/bankAccount/bankAccountActionConstants';
import {
  connectACHBankAccountSuccess,
  connectACHBankAccountError,
  fetchBankAccountsSuccess,
  fetchBankAccountsError,
} from '../actions/bankAccount/bankAccountActions';
import {
  connectACHBankAccountRequest,
  getBankAccountsRequest,
} from '../../request/bankAccountRequest';
import {
  formatErrorMessage,
  handleBankAccountError,
  rejectErrorCodeHelper,
} from '../../util/helpers/registerRejectErrorCodeHelper';

function* connectACHBankAccount({ payload }) {
  try {
    const { data } = yield call(connectACHBankAccountRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(connectACHBankAccountSuccess(data));
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    if (payload.setErrorMessages) {
      yield call(handleBankAccountError, {
        error,
        setErrorMessages: payload.setErrorMessages,
      });
    }
    yield put(connectACHBankAccountError(errorMessage));
  }
}

function* fetchBankAccounts({ payload }) {
  try {
    const { data } = yield call(getBankAccountsRequest, {
      ApplicationUid: payload.ApplicationUid,
    });
    if (data) {
      yield put(fetchBankAccountsSuccess(data));
    }
  } catch (error) {
    const errorMessage = yield call(formatErrorMessage, error);
    yield put(fetchBankAccountsError(errorMessage));
  }
}

export default function* bankAccountSaga() {
  yield all([
    takeLatest(CONNECT_ACH_BANK_ACCOUNTS, connectACHBankAccount),
    takeLatest(FETCH_BANK_ACCOUNTS, fetchBankAccounts),
  ]);
}
